import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { Loader2, Receipt } from 'lucide-react';
import { Sensitive } from '../Sensitive';
import { fmtMoney, fmtDay } from '../leadstore/WindowBanner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Agent's own lead-order receipts (used on Profile)
export const PaymentHistory = () => {
  const { getAuthHeader } = useAuth();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    axios.get(`${API}/lead-store/my-orders`, getAuthHeader())
      .then((res) => setOrders(res.data.orders || []))
      .catch(() => setOrders([]));
  }, [getAuthHeader]);

  if (!orders) return <div className="flex h-20 items-center justify-center"><Loader2 className="h-5 w-5 animate-spin text-[#2447D6]" /></div>;
  if (orders.length === 0) return <p className="rounded-2xl border border-dashed border-[#E9EDF7] py-6 text-center text-sm text-[#A3AED0]">No lead purchases yet.</p>;

  return (
    <div className="space-y-2" data-testid="my-payments-list">
      {orders.map((o) => (
        <div key={o.id} className="flex flex-wrap items-center gap-3 rounded-2xl border border-[#E9EDF7] bg-white px-4 py-3" data-testid={`payment-row-${o.order_number}`}>
          <Receipt className="h-4 w-4 text-[#2447D6]" />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-bold text-[#2B3674]">{o.package_name} <span className="font-mono text-[11px] font-medium text-[#A3AED0]">#{o.order_number}</span></p>
            <p className="text-[11px] text-[#A3AED0]">{o.paid_at ? new Date(o.paid_at).toLocaleDateString() : ''} · fulfillment from {fmtDay(o.fulfillment_starts)}</p>
          </div>
          <span className={`rounded-full px-2 py-0.5 text-[10px] font-extrabold uppercase ${o.payment_status === 'paid' ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`}>{o.payment_status}</span>
          <Sensitive className="w-20 text-right font-['Manrope'] text-sm font-extrabold text-[#2B3674]">{fmtMoney(o.amount_total ?? o.amount)}</Sensitive>
          <a href={`${API}/lead-store/orders/${o.id}/receipt`} target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold text-[#2447D6]">Receipt</a>
        </div>
      ))}
    </div>
  );
};
